<template>
  <div id="wrapper">

    <side-menu></side-menu>

    <div id="page-wrapper" class="gray-bg">

      <nav-menu></nav-menu>

      <bread-crumps title='Notificações' action='Visualizar'/>

      <div class="wrapper wrapper-content animated fadeIn">

        <div class="card">

          <div class="card-header">
            <h3 class="card-title"> <i class="fa fa-bell"></i> Notificações 'Toast'</h3>
          </div>

          <div class="card-body">
            <div class="portlet-body">
              <div class="row">

                <div class="col-md-3">

                  <div class="form-group">
                    <input type="text" class="form-control" v-model="title" placeholder="Escreva um título ...">
                  </div>

                  <div class="form-group">
                    <textarea class="form-control resize_vertical" rows="3" placeholder="Mensagem..." v-model="msg"></textarea>
                  </div>

                  <form>
                    <div class="form-group">
                      <label class="position-type" for="position-change"><b>Toaster Position</b></label>
                      <select name="toast-position" class="form-control" v-model="positionClass">
                        <option value="toast-top-left">Topo a Esquerda</option>
                        <option value="toast-top-right">Topo a Direita</option>
                        <option value="toast-top-center">Topo Centro</option>
                        <option value="toast-top-full-width">Topo Centro FULL</option>
                        <option value="toast-bottom-left">Base Esquerda</option>
                        <option value="toast-bottom-right">Base Direita</option>
                        <option value="toast-bottom-center">Base Centro</option>
                        <option value="toast-bottom-full-width">Base FULL</option>
                      </select>
                    </div>
                  </form>

                </div>

                <div class="col-md-3 ">
                  <div class="form-group">
                    <label class="toast-type">Tipo de Toast</label>
                    <div>
                      <label class="text-info">
                        <input type="radio" name="toasts" class="custom-radio" value="success" v-model="type"> Sucesso
                      </label>
                    </div>
                    <div>
                      <label class="text-success">
                        <input type="radio" name="toasts" class="custom-radio" value="info" v-model="type"> Informação
                      </label>
                    </div>
                    <div>
                      <label class="text-warning">
                        <input type="radio" name="toasts" class="custom-radio" value="warning" v-model="type"> Aviso
                      </label>
                    </div>
                    <div>
                      <label class="text-danger">
                        <input type="radio" name="toasts" class="custom-radio" value="error" v-model="type"> Erro
                      </label>
                    </div>
                  </div>
                  <div class="form-group">
                    <div>
                      <label for="closeButton">
                        <input type="checkbox" v-model="closeButton" class="input-small custom-checkbox"> Botão de Fechar
                      </label>
                    </div>
                    <div>
                      <label for="progressBar">
                        <input type="checkbox" class="input-small custom-checkbox" v-model="progressBar"> Barra de Progresso
                      </label>
                    </div>
                    <div>
                      <label for="preventDuplicates">
                        <input type="checkbox" class="input-small custom-checkbox" v-model="preventDuplicates"> Evitar duplicações
                      </label>
                    </div>
                    <div>
                      <label for="newestOnTop">
                        <input type="checkbox" class="input-small custom-checkbox" v-model="newestOnTop"> Mais recentes no topo
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">

                <div class="col-12 col-sm-4">
                  <button type="button" class="btn btn-success btn-raised toastrshow" @click="show_toast">
                    Show Toast
                  </button>
                </div>

                <div class="col-12 col-sm-4">
                  <button type="button" class="btn btn-danger btn-raised toastrshow" @click="clearall">
                    Limpar todas
                  </button>
                </div>

                <div class="col-12 col-sm-4">
                  <button type="button" class="btn btn-warning btn-raised toastrshow" @click="clearlast">
                    Limpar a ultima
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <page-footer></page-footer>

    </div>
  </div>
</template>

<script>

  import NavMenu from './layout/NavMenu'
  import SideMenu from './layout/SideMenu'
  import BreadCrumps from './layout/BreadCrumps'
  import PageFooter from './layout/PageFooter'

  export default {
    components: { NavMenu, SideMenu, BreadCrumps, PageFooter },
    data () {
      return {
        pageTitle: 'Notificações',

        selected:'',
        lasttoast: '',
        toastCount: 0,
        msg: 'Senhor dos Aneis ainda é épico!!',
        title: 'Sobre o Filme',
        type: "success",
        showDuration: "1000",
        hideDuration: "1000",
        timeOut: "5000",
        extendedTimeOut: "1000",
        closeButton: true,
        newestOnTop: false,
        progressBar: false,
        preventDuplicates: false,
        positionClass: "toast-top-right",
        showEasing: "swing",
        hideEasing: "swing",
        showMethod: "show",
        hideMethod: "hide"
      }
    },
    computed: {
      toastrOptions() {
        return 'Command: toastr["' + this.type + '"]("' + this.msg + (this.title ? '", "' + this.title : '') + '")\n\ntoastr.options = ' + JSON.stringify(toastr.options, null, 2)
      }
    },
    methods: {
      show_toast() {
        this.toastCount++

        toastr.options = {
          closeButton: this.closeButton,
          newestOnTop: this.newestOnTop,
          progressBar: this.progressBar,
          positionClass: this.positionClass,
          preventDuplicates: this.preventDuplicates,
          onclick: null
        }

        if (this.showDuration) {
          toastr.options.showDuration = this.showDuration;
        }
        if(this.timeOut) {
          toastr.options.timeOut = this.timeOut
        }

        if(this.extendedTimeOut) {
          toastr.options.extendedTimeOut = this.extendedTimeOut
        }
        if(this.hideDuration) {
          toastr.options.hideDuration = this.hideDuration
        }
        if(this.showEasing) {
          toastr.options.showEasing = this.showEasing
        }

        if(this.hideEasing) {
          toastr.options.hideEasing = this.hideEasing
        }

        if(this.showMethod) {
          toastr.options.showMethod = this.showMethod
        }

        if(this.hideMethod) {
          toastr.options.hideMethod = this.hideMethod
        }

        let $toast = toastr[this.type](this.msg, this.title)
        this.lasttoast = $toast;

        if(typeof $toast === 'undefined') { return }
      },
      getLastToast() {
        return this.lasttoast
      },
      clearlast() {
        toastr.clear(this.getLastToast())
      },
      clearall() {
        toastr.clear()
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/NotificationsPage.vue